import { Select } from "@mantine/core";
import { LuHeading } from "react-icons/lu";

export default function TextFormat({ editor, language }) {
  const headings = [
    {
      type: "heading",
      value: "1",
      label: language.TextEditor.Heading1,
    },
    {
      type: "heading",
      value: "2",
      label: language.TextEditor.Heading2,
    },
    {
      type: "heading",
      value: "3",
      label: language.TextEditor.Heading3,
    },
    {
      type: "paragraph",
      value: "4",
      label: language.TextEditor.Paragraph,
    },
  ];

  const getActiveHeading = (editor) => {
    return headings.find((heading) => {
      if (heading.type === "heading") {
        return editor.isActive("heading", { level: Number(heading.value) });
      }
      if (heading.type === "paragraph") {
        return editor.isActive("paragraph");
      }
      return false;
    });
  };

  const activeHeading = getActiveHeading(editor);

  if (!editor) return null;

  const onChangeSelect = (value) => {
    const selected = headings.find((item) => item.value === value);

    if (selected) {
      if (selected.type === "heading") {
        editor
          ?.chain()
          .focus()
          .toggleHeading({ level: Number(selected.value) })
          .run();
      } else if (selected.type === "paragraph") {
        editor?.chain().focus().setParagraph().run();
      }
    }
  };

  return (
    <Select
      data={headings}
      value={activeHeading ? activeHeading.value : null}
      onChange={onChangeSelect}
      leftSectionPointerEvents="none"
      leftSection={<LuHeading />}
      size="xs"
      placeholder={language.TextEditor.SelectHeadingPlaceholder}
      withCheckIcon={false}
      allowDeselect={false}
      styles={{ root: { marginLeft: "0.5rem", maxWidth: "125px" } }}
      comboboxProps={{ width: 150, position: "bottom-start" }}
    />
  );
}
